import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

export const VisulizadorDistribucion = ({
  almacenes,
  almaSelected,
  distributionConfig,
  clientes,
  partes
}) => {
  return (
    <Grid container spacing={0}>
      {almaSelected.map((alma, index) => (
        <Grid item xs={6} sx={{ p: 2, display: "flex", alignItems: "flex-start" }} key={alma.id}>
          <Paper sx={{ width: "100%", p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {alma.label}
            </Typography>

            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>{alma.secuencial ? "Prioridad" : "Racks"}</TableCell>
                    <TableCell>Cliente</TableCell>
                    <TableCell>Parte</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {distributionConfig[index].distribucion.map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{row.pp_alma_item_proridad || row.pp_alma_item_racks}</TableCell>
                      <TableCell>{clientes.find((c) => c.value === row.emp_id)?.label || "Cliente no encontrado"}</TableCell>
                      <TableCell>{partes.find((p) => p.value === row.part_id)?.label || "Parte no encontrada"}</TableCell>
                    </TableRow>
                  ))}

                  {distributionConfig[index].distribucion.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        align="center"
                        sx={{ color: "text.secondary" }}
                      >
                        Sin datos
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};
